import wizard from "@/mapping/wizard";
import internet from "@/mapping/internet";
import attached from "@/mapping/attached";
import vpnClient from "@/mapping/vpnClient";
import wan from "@/mapping/wan";
import lan from "@/mapping/lan";
import devname from "@/mapping/devname";
import upgrade from "@/mapping/upgrade";
import wireless from "@/mapping/wireless";
import guest from "@/mapping/guest";
import advWireless from "@/mapping/advWireless";
import upnp from "@/mapping/upnp";
import pfPt from "@/mapping/pfPt";
import ddns from "@/mapping/ddns";
import vlan from "@/mapping/vlan";
import accessControl from "@/mapping/accessControl";
import blockSites from "@/mapping/blockSites";
import blockServices from "@/mapping/blockServices";
import schedule from "@/mapping/schedule";
import rae from "@/mapping/rae";
import ntpSettings from "@/mapping/ntpSettings";
import ipv6 from "@/mapping/ipv6";
import traffic from "@/mapping/traffic";
import setPassword from "@/mapping/setPassword";
import staticRoutes from "@/mapping/staticRoutes";
import led from "@/mapping/led";
import email from "@/mapping/email";
import logs from "@/mapping/logs";
import vpnService from "@/mapping/vpnService";
import debug from "@/mapping/debug";
import resetPassword from "@/mapping/resetPassword";
import enableStringTable from "@/mapping/enableStringTable";
import lang from "@/mapping/lang";
import ipmac from "@/mapping/ipmac";
import webManage from "@/mapping/webManage";
export const mapping = {
  wizard,
  internet,
  attached,
  vpnClient,
  wan,
  lan,
  devname,
  upgrade,
  wireless,
  guest,
  advWireless,
  upnp,
  pfPt,
  ddns,
  vlan,
  accessControl,
  blockSites,
  blockServices,
  schedule,
  rae,
  ntpSettings,
  ipv6,
  traffic,
  setPassword,
  staticRoutes,
  led,
  email,
  logs,
  vpnService,
  debug,
  resetPassword,
  enableStringTable,
  lang,
  ipmac,
  webManage,
};

export default mapping;
